import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import { InsertScrewBody, SearchScrewsResponse, UpdateScrewBody } from "./types/screws";

export const useDeckScrewsApi = () => {
  const crud = createAdminCrudApi<SearchScrewsResponse, InsertScrewBody, UpdateScrewBody>(
    useApi(),
    DECK_ADMIN_URL,
    "screws",
  );

  return {
    useDeckScrews: crud.useSearch,
    getDeckScrews: crud.search,
    insertDeckScrew: crud.insert,
    updateDeckScrew: crud.update,
    deleteDeckScrew: crud.remove,
    updateDeckScrewVisibility: crud.updateVisibility,
    updateDeckScrewOrder: crud.updateOrder,
  };
};

export default useDeckScrewsApi;
